import {
  defaultPlugin,
  IPlugin,
} from '../../../../module-management/models/Plugin';
import { ElementType, IElement } from '../../../models/Element';

export type PluginsFeaturedPlugins = IElement & {
  heading: string;
  description: string;
  featured_plugins: Array<IPlugin>;
};

export const defaultPluginFeaturedPlugins: PluginsFeaturedPlugins = {
  id: 0,
  name: ElementType.PLUGIN_FEATURED_PLUGINS,
  heading: 'Relevante Add-Ons',
  description:
    'Voor makelaars is het van groot belang dat objecten (woningen en BOG) goed vindbaar zijn voor potentiële kopers. Dit kan tegenwoordig via Funda, Jaap en andere woningsites, maar ook de eigen website van de makelaar is hierin van essentieel belang.',
  featured_plugins: [defaultPlugin],
};
